import React, { useState, useEffect } from "react";
import { Container, Forms, ButtonContainer } from "./styles";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Input from "../components/Input";
import ActionButton from "../components/ActionButton";
import DateSelector from "../components/DateSelector";
import { HiOutlinePlus } from "react-icons/hi";
import { Modal } from "semantic-ui-react";
import AddAluno from "../components/Modals/AddAluno";
import ModelListarAluno from "../components/Modals/ListarAluno";
import { local, producaov2 as api } from "../../../../services/apis";
import swal from "sweetalert";
import { InputUrl } from "../components/InputUrl";
import { UpdateLogo } from "../components/uploadLogo";

const validateURL = (url) => {
  const notValidUrlWords = ["www", "incompany", "painel-empresa", "blog"];

  /**
   * URL pode conter as palavras não válidas, mas não pode ser igual
   */
  const notValidUrl = notValidUrlWords.find((word) => word === url);

  if (notValidUrl) {
    return `URL não pode ser igual a ${notValidUrl}`;
  }

  return "";
};

export const NovoCriarEmpresas = () => {
  const [name, setName] = useState("");
  const [collaboratorsTotal, setCollaboratorsTotal] = useState(null);
  const [managerEmail, setManagerEmail] = useState("");
  const [accessTime, setAccessTime] = useState("");
  const [companyUrl, setCompanyUrl] = useState("");
  const [logoUrl, setLogoUrl] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [showCollaborators, setShowCollaborators] = useState(false);
  const [collaboratorsEmails, setCollaboratorsEmails] = useState([]);
  const [managerEmailAdded, setManagerEmailAdded] = useState(false);
  const [loading, setLoading] = useState(false);

  const [licenseUse, setLicenseUse] = useState(0);

  const [erros, setErros] = useState({});

  useEffect(() => {
    const total = collaboratorsEmails.length;

    if (managerEmailAdded) {
      setLicenseUse(total + 1);
      return;
    }

    setLicenseUse(total);
  }, [collaboratorsTotal, managerEmailAdded, collaboratorsEmails]);

  const submitCompany = async () => {
    if (loading) return;
    const currentErros = {};

    const data = {
      name: name.trim(),
      collaboratorsTotal: +collaboratorsTotal,
      managerEmail: managerEmail.trim(),
      //accessTime: accessTime ? new Date(accessTime)?.toISOString() : null,
      collaboratorsEmails,
      url: companyUrl.trim(),
      logo: logoUrl.trim(),
    };

    Object.entries(data).forEach(([key, value]) => {
      if (!value) {
        currentErros[key] = "Campo obrigatório";
      }
    });

    if (collaboratorsEmails.length > collaboratorsTotal) {
      currentErros.collaboratorsTotal =
        "A quantidade de convites não pode ser maior que o número de colaboradores";
    }

    const urlError = validateURL(data.url);

    if (urlError) {
      currentErros.url = urlError;
    }

    if (Object.keys(currentErros).length > 0) {
      setErros(currentErros);
      return;
    }
    console.log(data);
    setLoading(true);

    await api
      .post("/admin/incompany/v3", data)
      .then((res) => {
        swal({
          title: "Sucesso",
          text: "Empresa criada com sucesso",
          icon: "success",
          button: "OK",
        }).then(() => {
          window.location.href = "/admin/lms";
        });
      })
      .catch((err) => {
        // Erro de email duplicado
        if (err?.response?.status === 409) {
          const emails = err.response.data.data.join(", ");
          swal({
            title: "Erro",
            text: `Os seguintes e-mails já estão cadastrados: ${emails}`,
            icon: "error",
            button: "OK",
          });
          return;
        }

        swal({
          title: "Erro",
          text: `Erro ao criar empresa. ${err?.response?.data?.message}`,
          icon: "error",
          button: "OK",
        });
      });

    setLoading(false);
  };

  return (
    <div style={{ width: "100%", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <div>
          <h1>Criar Empresa</h1>
        </div>

        <Forms>
          <div className="content">
            <Input
              label="Nome da Empresa"
              value={name}
              setValue={setName}
              placeholder="Nome da Empresa"
              onFocus={() => setErros((prev) => ({ ...prev, name: "" }))}
              error={erros.name}
            />
            <div>
              <Input
                label="Total de colaboradores no painel"
                value={collaboratorsTotal || ""}
                setValue={(value) => {
                  const onlyNumber = value.replace(/[^0-9]/g, "");
                  if (!onlyNumber) {
                    setCollaboratorsTotal(null);
                  }
                  setCollaboratorsTotal(+onlyNumber);
                }}
                min={licenseUse || 0}
                error={erros.collaboratorsTotal}
                onFocus={() =>
                  setErros((prev) => ({ ...prev, collaboratorsTotal: "" }))
                }
              />
              <div className="buttons">
                {collaboratorsEmails.length > 0 && (
                  <ActionButton
                    text="Ver colaboradores"
                    onClick={() => setShowCollaborators(true)}
                  />
                )}
                {!!collaboratorsTotal && (
                  <ActionButton
                    text="Adicionar colaboradores"
                    icon={<HiOutlinePlus size={18} />}
                    onClick={() => setModalOpen(true)}
                  />
                )}
              </div>
            </div>

            <InputUrl
              value={companyUrl}
              setValue={setCompanyUrl}
              error={erros.url}
              onFocus={() => setErros((prev) => ({ ...prev, url: "" }))}
            />
          </div>

          <div className="content">
            <UpdateLogo
              name={name}
              logoUrl={logoUrl}
              setLogoUrl={setLogoUrl}
              error={erros.logo}
              cleanError={() => setErros((prev) => ({ ...prev, logo: "" }))}
            />

            {/* <DateSelector
              label='Tempo de Acesso'
              value={accessTime}
              setValue={setAccessTime}
              error={erros.accessTime}
              onFocus={() => setErros(prev => ({ ...prev, accessTime: '' }))}
            /> */}

            <Input
              label="Gestor da Empresa"
              description="E-mail do Administrador Master (RH)"
              value={managerEmail}
              placeholder="E-mail do gestor"
              setValue={setManagerEmail}
              error={erros.managerEmail}
              onFocus={() =>
                setErros((prev) => ({ ...prev, managerEmail: "" }))
              }
              disabled={
                !collaboratorsTotal ||
                (licenseUse === collaboratorsTotal && !managerEmailAdded)
              }
              onBlur={() => setManagerEmailAdded(!!managerEmail)}
            />
          </div>
        </Forms>
        <ButtonContainer>
          <button onClick={submitCompany}>
            {loading ? (
              <div className="load" />
            ) : (
              " Criar Painel e Enviar convite"
            )}
          </button>
        </ButtonContainer>

        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <AddAluno
            closeModal={() => setModalOpen(false)}
            invitationTotal={collaboratorsTotal}
            setEmails={setCollaboratorsEmails}
            emails={collaboratorsEmails}
            licenseUse={licenseUse}
          />
        </Modal>

        <Modal
          open={showCollaborators}
          onClose={() => setShowCollaborators(false)}
        >
          <ModelListarAluno
            closeModal={() => setShowCollaborators(false)}
            emails={collaboratorsEmails}
            setEmails={setCollaboratorsEmails}
          />
        </Modal>
      </Container>
    </div>
  );
};
